import { JobRating } from "../common/JobOrder";

export const jobRatingEnumToString = () => {
  return Object.values(JobRating);
};

export const jobRatingStringToEnum = (rating: string) => {
  return Object.values(JobRating).find((item) => {
    // check for both prepended _ and without
    if (item.toString() === rating || item.toString().slice(1) === rating) {
      return true;
    }
    return undefined;
  });
};
